import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "reactstrap";
import "../styles/brand-auth.css";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import useReveal from "hooks/useReveal";

/* /account-deleted — where Account settings → Delete account lands.

   Public on purpose: by the time this renders the account, its sign-in and
   its session are already gone, so a signed-in guard would bounce the person
   to the login page instead of telling them it worked. It asks the backend
   nothing; it only confirms what already happened.

   What it knows comes from the navigation state DeleteAccountSection sets:
   { deleted: true, emailSent }. Without it (someone typed or shared the
   address) there is nothing to confirm, so it goes home rather than tell a
   stranger their account was deleted. emailSent is false whenever the email
   was not sent (no sender configured, the provider failed, no proven address,
   a retry of an already finished deletion), and then the page must not
   promise one.

   Same navy shell and card as the forgot-password page (styles/brand-auth.css). */
const AccountDeleted = () => {
  // The card's entrance — see styles/premium.css.
  useReveal();
  const { t } = useTranslation();
  const { state } = useLocation();

  if (!state?.deleted) return <Navigate to="/" replace />;
  const emailSent = state.emailSent === true;

  return (
    <>
      <DemoNavbar />
      <main className="cn-auth">
        <section className="cn-auth-hero cn-grid">
          <span className="cn-grain" aria-hidden="true" />
          <span className="cn-orb cn-orb-1" />
          <span className="cn-orb cn-orb-2" />
          <span className="cn-orb cn-orb-3" />

          <Container>
            <Row className="justify-content-center">
              <Col xs="12" md="10" lg="6" xl="5">
                <div className="cn-card" data-reveal>
                  <div className="cn-card-head">
                    <h1 className="cn-title">{t("deleteAccount.doneTitle")}</h1>
                    <p className="cn-sub">
                      {t(emailSent ? "deleteAccount.doneBody" : "deleteAccount.doneBodyNoEmail")}
                    </p>
                  </div>

                  {/* The email is the person's record of this. */}
                  {emailSent && (
                    <p className="cn-hint" style={{ margin: "0 0 24px" }}>
                      {t("deleteAccount.doneNote")}
                    </p>
                  )}

                  <Link to="/" className="cn-btn-primary cn-btn-block cn-btn-arrow">
                    {t("deleteAccount.doneHome")}
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <MainFooter />
    </>
  );
};

export default AccountDeleted;
